angular.module('BBPublicBooking').directive('bbPaypal', (PathSvc) => {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                ppDetails: '=bbPaypal'
            },
            templateUrl: PathSvc.directivePartial('paypal_button'),
            link(scope, element, attrs) {
                scope.inputs = [];

                if (!scope.ppDetails) {
                    return;
                }

                const keys = _.keys(scope.ppDetails);
                //  convert the paypal data to an array of input objects
                return _.each(keys, (keyName) => {
                    const obj = {
                        name: keyName,
                        value: scope.ppDetails[keyName]
                    };
                    return scope.inputs.push(obj);
                });
            }
        };
    }
);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/paypal-buttons/bb_paypal.directive.js